import { Flex } from '@iheartjane/reefer';
import type { MouseEvent } from 'react';

import styles from './selectedIndicator.module.css';

interface SelectedIndicatorProps {
  isSelected: boolean;
  onToggle: () => void;
  productName: string;
}

/**
 * Marks a product card as selected, and deselects it when clicked. Renders
 * nothing while unselected.
 */
export const SelectedIndicator = ({
  isSelected,
  onToggle,
  productName,
}: SelectedIndicatorProps) => {
  if (!isSelected) return null;

  const handleClick = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onToggle();
  };

  return (
    <Flex background="grays-white" border="grays-ultralight" borderRadius="xl">
      <button
        type="button"
        className={styles['indicator']}
        onClick={handleClick}
        aria-label={`Remove ${productName} from selection`}
      >
        <span className={styles['dot']} aria-hidden="true" />
      </button>
    </Flex>
  );
};
